// extracted by mini-css-extract-plugin
export var actionText = "_qx-4";
export var container = "_qx-0";
export var leftSection = "_qx-1";
export var rightSection = "_qx-2";
export var settingsButton = "_qx-6";
export var settingsIcon = "_qx-7";
export var shortcut = "_qx-5";
export var shortcutGroup = "_qx-3";